import { z } from 'zod'
import { stringSchema } from './common'

const hexColorSchema = stringSchema.regex(
  /^#(?:[0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/,
  'Invalid HEX color',
)

const straplineAlignmentSchema = z.enum(['left', 'center', 'right'])

export const straplineSchema = z.object({
  id: stringSchema.min(1),
  name: stringSchema.min(1),
  text: stringSchema.min(1),
  alignment: straplineAlignmentSchema,
  backgroundColour: hexColorSchema,
  textColour: hexColorSchema,
  linkHoverColour: hexColorSchema,
  position: z.number().int(),
})

export const straplinesSchema = z.array(straplineSchema)

export type Strapline = z.infer<typeof straplineSchema>
